import { Link } from "react-router-dom";
import { COMPANY_INFO as C } from "constants/policyContent";

/**
 * 계정 삭제(회원탈퇴) 안내 — 로그인 없이 누구나 보는 공개 페이지.
 *  ★ Google Play '데이터 보안 > 계정 삭제 URL' 로 등록하는 주소다. Play 요건:
 *    앱·개발자 이름, 삭제 요청 단계, 삭제·보관되는 데이터와 보관 기간이 이 페이지에 보여야 한다.
 *  ⚠️ 보관 기간 문구는 개인정보처리방침 제4조(constants/policyContent.js)와 맞출 것.
 *  새 CSS 없이 약관 화면 스타일(#privacy_policy_detail .privacy-policy)을 그대로 쓴다 — id 를 바꾸면 스타일이 빠진다.
 */
const listStyle = { paddingLeft: "1.6rem", listStyle: "disc" };

export const AccountDeletion = () => (
  <div id="privacy_policy_detail" className="page">
    <div className="content-wrap">
      <div className="privacy-policy">
        <div className="section">
          <h3>무용연 계정 삭제 안내</h3>
          <p>
            무용연 앱과 웹(muyeon.co.kr)은 {C.name}(대표 {C.ceo})가 운영해요. 회원은 언제든 직접 탈퇴해서 계정과
            개인정보 삭제를 요청할 수 있어요.
          </p>

          <h4 style={{ marginTop: "1.6rem" }}>앱에서 탈퇴하기</h4>
          <ol>
            <li>무용연 앱에 로그인해요.</li>
            <li>아래 메뉴의 MY 탭을 눌러요.</li>
            <li>개인정보 관리를 누르고, 화면 아래의 회원탈퇴를 눌러요.</li>
            <li>탈퇴 사유를 고르고 안내에 동의한 뒤 본인 확인을 마치면 탈퇴가 완료돼요.</li>
          </ol>

          <h4 style={{ marginTop: "1.6rem" }}>웹에서 탈퇴하기</h4>
          <p>
            muyeon.co.kr 에 로그인한 뒤 MY, 개인정보 관리, 회원탈퇴 순서로 들어가면 돼요.{" "}
            <Link to="/withdraw">회원탈퇴 화면으로 가기</Link>
          </p>

          <h4 style={{ marginTop: "1.6rem" }}>로그인할 수 없을 때</h4>
          <p>
            가입한 이메일 주소나 휴대전화번호를 적어 고객센터 메일({C.email})로 탈퇴를 요청해 주세요. 본인 확인을 거쳐 처리해 드려요.
          </p>

          <h4 style={{ marginTop: "1.6rem" }}>탈퇴 전에 확인해 주세요</h4>
          <ul style={listStyle}>
            <li>진행 중인 예약, 남은 이용권, 이용 중인 유료서비스, 상대방의 응답을 기다리는 거래가 있으면 먼저 정리해야 탈퇴할 수 있어요.</li>
            <li>탈퇴하면 계정은 바로 이용할 수 없고, 프로필과 공고도 바로 보이지 않아요.</li>
            <li>탈퇴일부터 3개월 동안은 같은 이메일, 휴대전화번호, 본인확인 정보로 다시 가입할 수 없어요.</li>
          </ul>

          <h4 style={{ marginTop: "1.6rem" }}>삭제되는 정보</h4>
          <ul style={listStyle}>
            <li>계정·로그인 정보, 이름, 프로필 사진, 소개, 경력·학력·자격·수상·공연 이력, 활동지역·희망조건, SNS 주소, 이력서</li>
            <li>강사·학원·공연팀 등 활동유형 프로필과 공개 공고(비공개 처리 후 삭제)</li>
            <li>견적·자동견적 설정, 찜·검색·추천 설정, 기기 알림 토큰, 광고성 정보 수신 설정</li>
          </ul>

          <h4 style={{ marginTop: "1.6rem" }}>남거나 일정 기간 보관되는 정보</h4>
          <ul style={listStyle}>
            <li>게시글·댓글·후기: 다른 회원의 권리 보호를 위해 남겨야 하는 경우 작성자 정보를 지우고 "탈퇴한 회원"으로 표시해요. 삭제를 원하면 탈퇴 전에 직접 지우거나 요청해 주세요.</li>
            <li>채팅: 상대방에게 이미 전달된 메시지는 보낸 사람을 알 수 없게 처리해서 남을 수 있어요. 프로필 사진, 연락처, 첨부파일은 삭제하거나 볼 수 없게 막아요.</li>
            <li>부정 재가입 방지 정보(이메일·휴대전화번호·본인확인 정보를 알아볼 수 없게 바꾼 값과 탈퇴 일시): 3개월 보관 후 삭제</li>
            <li>신고·분쟁이 접수된 대화와 자료: 사건 종결일부터 3년 보관 후 삭제</li>
            <li>법에 따라 보관하는 거래 기록: 계약·청약철회 기록과 대금결제·서비스 공급 기록 5년, 소비자 불만·분쟁 처리 기록 3년, 표시·광고 기록 6개월, 접속 기록 3개월</li>
          </ul>

          <p style={{ marginTop: "1.6rem" }}>
            자세한 내용은 <Link to="/policy?doc=privacy">개인정보처리방침</Link>에서 볼 수 있어요.
          </p>
          <p className="t-13-single fc-s" style={{ marginTop: "1.2rem" }}>
            문의: {C.email} · {C.tel}
          </p>
        </div>
      </div>
    </div>
  </div>
);
